// extracted by mini-css-extract-plugin
module.exports = {"expanded-timeline-entry-content":"expanded-timeline-entry-content__expanded-timeline-entry-content___3o82J"};